import { useEffect, useState } from "react";
import { Bell, BellOff } from "lucide-react";
import { isSoundEnabled, setSoundEnabled, playChime } from "../lib/notify";

export default function SoundToggle() {
  const [on, setOn] = useState(true);

  useEffect(() => {
    setOn(isSoundEnabled());
  }, []);

  const toggle = () => {
    const next = !on;
    setOn(next);
    setSoundEnabled(next);
    if (next) {
      // Test chime so the user knows sound is active.
      playChime();
    }
  };

  return (
    <button
      type="button"
      onClick={toggle}
      data-testid="sound-toggle"
      aria-pressed={on}
      title={on ? "Sound on — click to mute" : "Sound muted — click to enable"}
      className={`h-9 w-9 inline-flex items-center justify-center border rounded-none transition-colors ${
        on
          ? "border-zinc-300 text-zinc-900 hover:bg-zinc-100"
          : "border-zinc-200 text-zinc-400 hover:text-zinc-700 hover:border-zinc-300"
      }`}
    >
      {on ? <Bell className="h-4 w-4" /> : <BellOff className="h-4 w-4" />}
    </button>
  );
}
